import { useEffect } from 'react';

import { Trans } from '@lingui/react/macro';
import { useLocation } from 'react-router';

import { InvalidLinkMessage } from '@/modules/preQualify/components/InvalidLinkMessage';
import { trackPreQualifyEvent } from '@/modules/preQualify/trackPreQualifyEvent';
import { mixpanelEvents } from '@/utils/mixpanel';

import { InformationCollectedResult } from './components/InformationCollectedResult';
import { usePreQualifyReport } from './usePreQualifyReport';

export const PreQualifyReportPage = () => {
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const dealId = params.get('code');

  const { data, isLoading, isError } = usePreQualifyReport(dealId);

  useEffect(() => {
    if (dealId && data) {
      trackPreQualifyEvent(dealId, mixpanelEvents.preQualifyReportView, {
        dealId,
        compatible: data.compatible,
      });
    }
  }, [dealId, data]);

  return (
    <div className="vai-font-inter vai-flex vai-min-h-screen vai-flex-col vai-items-center vai-bg-gray-50 vai-px-4 vai-py-8">
      <div className="vai-w-full vai-max-w-md vai-rounded-lg vai-bg-white vai-p-8 vai-shadow-sm">
        <h1 className="vai-mb-6 vai-text-center vai-text-2xl vai-font-bold">
          <Trans>Videa Compatibility Check</Trans>
        </h1>

        {!dealId ? (
          <InvalidLinkMessage
            message={
              <Trans>
                This link appears to be incomplete. Please use the link provided
                to access the compatibility check.
              </Trans>
            }
          />
        ) : isLoading ? (
          <LoadingState />
        ) : isError ? (
          <InvalidLinkMessage
            heading={null}
            message={
              <Trans>Something went wrong. Please try again later.</Trans>
            }
          />
        ) : data?.compatible ? (
          // for now, no matter what, we show the neutral screen
          // <CompatibleResult />ƒ
          <InformationCollectedResult />
        ) : (
          <InformationCollectedResult />
        )}

        {/* TODO: CTA button — not sure what the call-to-action should be yet
        <div className="vai-mt-6 vai-flex vai-justify-center">
          <a
            href={VIDEA_WEBSITE_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="vai-rounded-md vai-bg-gray-900 vai-px-6 vai-py-2.5 vai-text-sm vai-font-semibold vai-text-white hover:vai-bg-gray-800"
            onClick={() =>
              trackEvent(mixpanelEvents.preQualifyReportTryVideaClick, {
                dealId,
              })
            }
          >
            <Trans>Try Videa Now</Trans>
          </a>
        </div>
        */}
      </div>
    </div>
  );
};

const LoadingState = () => (
  <div className="vai-flex vai-flex-col vai-items-center vai-space-y-3 vai-py-8">
    <div className="vai-h-8 vai-w-8 vai-animate-spin vai-rounded-full vai-border-4 vai-border-gray-200 vai-border-t-gray-600" />
    <p className="vai-text-sm vai-text-gray-500">
      <Trans>Checking compatibility...</Trans>
    </p>
  </div>
);
